'use client'

import { MultiOrderTitle } from 'my-purchases/components/MultiOrderTitle/MultiOrderTitle'
import { OrderStatusTitle } from 'my-purchases/components/OrderStatusTitle/OrderStatusTitle'
import type { OrderDetails } from 'my-purchases/types/purchaseDetail'
import type { OrderStatusDetail } from 'my-purchases/types/purchaseStatus'

interface OrderHeaderProps {
	readonly order: OrderDetails | OrderStatusDetail
	readonly orderIndex: number
	readonly showMultiTitle?: boolean
	readonly className?: string
}

export function OrderHeader({
	order,
	orderIndex,
	showMultiTitle,
	className,
}: OrderHeaderProps) {
	return (
		<div className={className}>
			{showMultiTitle && <MultiOrderTitle orderIndex={orderIndex} />}
			<OrderStatusTitle order={order} />
		</div>
	)
}
